var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" File upload "),_c('div',[_c('input',{attrs:{"type":"file"},on:{"change":_vm.handleChange}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }